import html2canvas from "html2canvas";

const TONEN = "button, [role='tab'], th, thead, h1, h2, h3, label, nav, [data-rondleiding-tonen], [data-rondleiding-overlay]";

/** Rechthoeken (viewport-coördinaten) van alle tekst en invoervelden die géén knop/kop/label zijn: daar staan klant- en persoonsgegevens. */
function gevoeligeVlakken(root) {
  const rects = [];
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let n = walker.nextNode();
  while (n) {
    const ouder = n.parentElement;
    if (n.textContent.trim() && ouder && !ouder.closest(TONEN)) {
      const range = document.createRange();
      range.selectNodeContents(n);
      rects.push(...range.getClientRects());
    }
    n = walker.nextNode();
  }
  root.querySelectorAll("input, textarea, select, img, [data-gevoelig]").forEach((el) => { if (!el.closest("[data-rondleiding-overlay]")) rects.push(el.getBoundingClientRect()); });
  return rects.filter((r) => r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight);
}

/** Schermafbeelding van het zichtbare deel van het scherm, met persoonsgegevens vervaagd (besluit 2-11: 'PDF vervagen'). */
export async function vervaagdeSchermafbeelding() {
  const root = document.querySelector("main") || document.body;
  const vlakken = gevoeligeVlakken(root);
  const canvas = await html2canvas(document.body, {
    x: window.scrollX, y: window.scrollY, width: window.innerWidth, height: window.innerHeight, scale: 1, useCORS: true, logging: false,
    ignoreElements: (el) => el.hasAttribute?.("data-rondleiding-overlay"),
  });
  const ctx = canvas.getContext("2d");
  const klein = document.createElement("canvas");
  const kctx = klein.getContext("2d");
  vlakken.forEach((r) => {
    const w = Math.ceil(r.width) + 4, h = Math.ceil(r.height) + 4, x = Math.floor(r.left) - 2, y = Math.floor(r.top) - 2;
    klein.width = Math.max(1, Math.round(w / 8));
    klein.height = Math.max(1, Math.round(h / 8));
    kctx.drawImage(canvas, x, y, w, h, 0, 0, klein.width, klein.height);
    ctx.imageSmoothingEnabled = true;
    ctx.drawImage(klein, 0, 0, klein.width, klein.height, x, y, w, h);
  });
  return new Promise((ok) => canvas.toBlob(ok, "image/png"));
}
